import React from 'react';

const DottedLine = () => {
  return (
    <svg
      className="dotted-line"
      viewBox="0 0 200 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="animated-dotted-line"
        d="M100 0 
           V140 
           Q100 180, 60 180 
           H-80 
           Q-120 180, -120 220 
           V300"
        stroke="#14144B"
        strokeWidth="2"
        strokeDasharray="6 6"
        fill="none"
      />
    </svg>
  );
};

export default DottedLine;
